/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIPanel from 'UIComponents/panel/UIPanel';
import { getFullUrl } from 'hubspot-url-utils';
import ConflictErrorAlert from '../components/alerts/ConflictErrorAlert';
import EscalationPanelBody from '../components/panel/EscalationPanelBody';
import EscalationPanelFooter from '../components/panel/EscalationPanelFooter';
import EscalationPanelHeader from '../components/panel/EscalationPanelHeader';
import Track from '../utils/EscalationsTracker';
import { loadEscalation, loadEscalationMeta, saveEscalation, submitEscalation } from '../actions/EscalationActions';
import { clearErrors } from '../actions/ErrorActions';
import { renderComponent } from '../utils/EscalationFactory';
import { isSubmittable } from '../utils/EscalationValidator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const COMPACT_SIZE = 320;
const WIDE_SIZE = 540;

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'ticketId' implicitly has an 'any' type.
const buildSuccessAlert = (ticketId, type) => ({
  message: type === 'title-with-message' ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "app.escalations.alerts.submission.success.body_jsx",
    elements: {
      Link: UILink
    },
    options: {
      external: true,
      href: `${getFullUrl('tools', {
        domainOverride: 'hubteam'
      })}/zorse/53/inbox/ticket/${ticketId}`
    }
  }) : null,
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.escalations.alerts.submission.success.title"
  }),
  type: 'success'
});
const buildErrorAlert = () => ({
  message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "app.escalations.alerts.submission.error.body_jsx",
    elements: {
      Link: UILink
    },
    options: {
      external: true,
      href: 'https://hubspot.slack.com/archives/C12V50UGZ/'
    }
  }),
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.escalations.alerts.submission.error.title"
  }),
  type: 'danger'
});
function EscalationPanel(props) {
  const dispatch = useDispatch();
  useEffect(() => {
    Track.applicationName = props.applicationName;
    Track.conversationId = props.conversationId;
    Track.ticketId = props.ticketId;
    Track.openPanel();
  }, [props.applicationName, props.conversationId, props.ticketId]);
  useEffect(() => {
    dispatch(loadEscalation({
      conversationId: props.conversationId,
      ticketId: props.ticketId
    }));
    dispatch(loadEscalationMeta({
      conversationId: props.conversationId,
      ticketId: props.ticketId
    }));
  }, [dispatch, props.conversationId, props.ticketId]);
  const escalation = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.escalation);
  const escalationMeta = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.escalationMeta);
  const loadingState = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.loadingState);
  const savingState = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.savingState);
  const errorState = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.errorState);
  const outOfTheOffice = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.outOfTheOffice);
  const handleSubmissionSuccess = () => {
    if (props.alertStore) {
      props.alertStore.addAlert(buildSuccessAlert(escalation.ticketId, props.notificationType));
    }
    props.onSubmit();
  };
  const handleSubmissionError = () => {
    if (props.alertStore) {
      props.alertStore.addAlert(buildErrorAlert());
    }
    props.onError();
  };
  return /*#__PURE__*/_jsxs(UIPanel, {
    width: props.isCompact ? COMPACT_SIZE : WIDE_SIZE,
    children: [/*#__PURE__*/_jsx(EscalationPanelHeader, {
      "data-test-id": "escalation-panel-header",
      onClose: () => {
        Track.closePanel({
          isCancelled: false
        });
        props.onClose();
      }
    }), /*#__PURE__*/_jsx(EscalationPanelBody, {
      accountManager: escalationMeta.accountManager,
      contractManager: escalationMeta.contractManager,
      "data-test-id": "escalation-panel-body",
      escalation: escalation,
      isSaving: savingState.type,
      isLoading: loadingState.isLoading || savingState.submission,
      isStarterPortal: escalationMeta.isStarterPortal,
      onUpdate: updatedEscalation => dispatch(saveEscalation(updatedEscalation.setReason(undefined).toJS(), 'type'))
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element | undefined' is not assignable to ty... Remove this comment to see the full error message
      ,
      error: errorState.hasConflictError ? /*#__PURE__*/_jsx(ConflictErrorAlert, {
        onResolve: () => {
          dispatch(loadEscalation({
            conversationId: props.conversationId,
            ticketId: props.ticketId
          }));
          dispatch(clearErrors());
        }
      }) : undefined,
      children: renderComponent(escalation.type)
    }), /*#__PURE__*/_jsx(EscalationPanelFooter, {
      canSubmit: isSubmittable({
        escalation,
        errorState,
        savingState,
        outOfTheOffice
      }),
      "data-test-id": "escalation-panel-footer",
      onCancel: () => {
        Track.closePanel({
          isCancelled: true
        });
        props.onClose();
      },
      onSubmit: () => {
        Track.submitEscalation(escalation);
        dispatch(submitEscalation(escalation)).then(handleSubmissionSuccess, handleSubmissionError);
      }
    })]
  });
}
EscalationPanel.propTypes = {
  alertStore: PropTypes.object,
  applicationName: PropTypes.string.isRequired,
  conversationId: PropTypes.number,
  isCompact: PropTypes.bool,
  notificationType: PropTypes.oneOf(['title-only', 'title-with-message']),
  onClose: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  ticketId: PropTypes.number
};
EscalationPanel.defaultProps = {
  alertStore: null,
  conversationId: 0,
  isCompact: true,
  notificationType: 'title-with-message',
  ticketId: 0
};
export default EscalationPanel;